import { Routes, RouterModule } from '@angular/router';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { LoginLoginComponent } from './login/components/login.component';
import { LoginRegisterComponent } from './login/components/register.component';
import { LoginRegistrationConfirmationComponent } from './login/components/registration-confirmation.component';
import { LoginRegistrationSuccessComponent } from './login/components/registration-success.component';
import { LoginResetPassConfirmationComponent } from './login/components/reset-password-confirmation.component';
import { LoginResetPasswordComponent } from './login/components/reset-password.component';
import { LoginSetNewPasswordComponent } from './login/components/set-new-password.component';
import { LoginChangePasswordComponent } from './login/components/change-password.component';

import { InformationFaqComponent } from './information/components/faq.component';
import { InformationContactUsComponent } from './information/components/contact-us.component';

import { HomeComponent } from './home/components/home.component';

import { CustomerHistoryComponent } from './history/components/customer-history.component';

import { PlantmapEarthworkDetailsComponent } from './plantmap/components/earthwork-details.component';
import { PlantmapAreaOfInterestComponent } from './plantmap/components/area-of-interest.component';
import { PlantmapUploadDocumentComponent } from './plantmap/components/upload-document.component';
import { PlantmapPaymentComponent } from './plantmap/components/payment.component';
import { PlantmapConfirmationComponent } from './plantmap/components/confirmation.component';

import { NceFillInParticularsComponent } from './nce/components/fill-in-particulars.component';
import { NceFillInParticularsExtComponent } from './nce/components/fill-in-particulars-ext.component';
import { NceEarthworkDetailsComponent } from './nce/components/earthwork-details.component';
import { NceUploadAttachmentComponent } from './nce/components/upload-attachment.component';
import { NceDeclarationComponent } from './nce/components/declaration.component';
import { NcePreviewComponent } from './nce/components/preview.component';
import { EditPreviewChildComponent } from './admin/components/edit-preview-child.component';
import { NcePaymentComponent } from './nce/components/payment.component';
import { NceConfirmationComponent } from './nce/components/confirmation.component';
import { NceBriefingSessionComponent } from './nce/components/briefing-session.component';
import { NceBriefingDocumentComponent } from './nce/components/briefing-document.component';
import { NceMakeAppointmentComponent } from './nce/components/make-appointment.component';
import { NceAppointmentUploadComponent } from './nce/components/appointment-upload.component';
import { NceFinalApprovalComponent } from './nce/components/final-approval.component';
import { NceApplyForFinalApprovalComponent } from './nce/components/apply-for-final-approval.component';
import { NceViewComponent } from './nce/components/view.component';

import { AdminCreateAccountComponent } from './admin/components/create-account.component';
import { AdminUserAccountComponent } from './admin/components/user-account.component';
import { AdminViewUserDetailsComponent } from './admin/components/view-user-details.component';

//GANESH
import { AdminReportComponent } from './admin/components/admin-report.component';


import { PlantmapAdminAllComponent } from './plantmap-admin/components/all.component';

import { NceAdminAllComponent } from './nce-admin/components/all.component';
import { NceAdminRequestComponent } from './nce-admin/components/request.component';

import { ProfileUpdateProfileComponent } from './profile/components/update-profile.component';

import { InNavGuardService,OutNavGuardService } from './shared/services/nav-guard.service';
import { MaintenanceComponent } from 'app/information/components/maintenance.component';

import { paymentTnCComponent } from './shared/configuration/payment-tnc.component'; //Kowsalya
import { cancelconfirmation } from './plantmap/components/confirmation-cancel.component';//Kowsalya
import { timeoutconfirmation } from './plantmap/components/confirmation-timeout.component';//Kowsalya
import { PrivacyComponent } from './information/components/privacy/privacy.component';//Anjaiah
import { TermsComponent } from './information/components/terms/terms.component';//Anjaiah


const routes: Routes = [
	{
		path: '',   
		redirectTo: '/login', 
		pathMatch: 'full'
	},
	{
		path: 'maintenance',
		component: MaintenanceComponent,
		pathMatch: 'full'
	},
	{   
		path: 'login',
		canActivate: [InNavGuardService],
		component: LoginLoginComponent
	},
	{   
		path: 'faq',
		//canActivate: [InNavGuardService],
		component: InformationFaqComponent
	},
	{   
		path: 'contact-us',
		canActivate: [InNavGuardService],
		component: InformationContactUsComponent
	},
	{
		path: 'privacy-policy',
		//canActivate: [InNavGuardService],
		component: PrivacyComponent
	},
	{
		path: 'terms-of-use',
		component: TermsComponent
	},
	{   
		path: 'register',
		canActivate: [InNavGuardService],
		component: LoginRegisterComponent
	},
	{   
		path: 'registration-confirmation',
		canActivate: [InNavGuardService], 
		component: LoginRegistrationConfirmationComponent
	},
	{   
		path: 'registration-success',
		canActivate: [InNavGuardService], 
		component: LoginRegistrationSuccessComponent
	},
	{   
		path: 'reset-password',
		canActivate: [InNavGuardService],
		component: LoginResetPasswordComponent
	},
	{   
		path: 'set-new-password',
		canActivate: [InNavGuardService], 
		component: LoginSetNewPasswordComponent
	},
	{   
		path: 'reset-password-confirmation',
		canActivate: [InNavGuardService], 
		component: LoginResetPassConfirmationComponent
	},
	{   
		path: 'change-password',
		canActivate: [InNavGuardService], 
		component: LoginChangePasswordComponent
	},
	{   
		path: 'home',
		canActivate: [InNavGuardService], 
		component: HomeComponent
	},
	{   
		path: 'customer-history',
		canActivate: [InNavGuardService], 
		component: CustomerHistoryComponent
	},
	{
		path: 'plant-map',
		canDeactivate: [OutNavGuardService],  
		children:
		[
			{
				path: 'earthwork-details',
				canActivate: [InNavGuardService],
				component: PlantmapEarthworkDetailsComponent
			},
			{
				path: 'area-of-interest',
				canActivate: [InNavGuardService],
				component: PlantmapAreaOfInterestComponent
			},
			{
				path: 'upload-document',
				canActivate: [InNavGuardService],
				component: PlantmapUploadDocumentComponent
			},
			{
				path: 'payment',
				canActivate: [InNavGuardService],
				component: PlantmapPaymentComponent
			},
			{
				path: 'confirmation',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: PlantmapConfirmationComponent
			},

			//Kowsalya
			{
				path: 'confirmation-cancel',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: cancelconfirmation
			},
			{
				path: 'confirmation-timeout',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: timeoutconfirmation
			},
			//Kowsalya

			{
				path: 'all',
				canActivate: [InNavGuardService],
				component: PlantmapAdminAllComponent
			}
		]
	},
	{
		path: 'nce-application',
		canActivate: [InNavGuardService],
		children:
		[
			{
				path: 'fill-in-particulars',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceFillInParticularsComponent
			},
			{
				path: 'fill-in-particulars-ext',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceFillInParticularsExtComponent
			},
			{
				path: 'earthwork-details',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceEarthworkDetailsComponent
			},
			{
				path: 'upload-attachment',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceUploadAttachmentComponent
			},
			{
				path: 'declaration',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceDeclarationComponent
			},
			{
				path: 'preview',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NcePreviewComponent
			},
			{
				path: 'edit-preview',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: EditPreviewChildComponent
			},
			{
				path: 'payment',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NcePaymentComponent
			},
			{
				path: 'confirmation',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceConfirmationComponent
			},
			{
				path: 'briefing-session',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceBriefingSessionComponent
			},
			{
				path: 'make-appointment',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceMakeAppointmentComponent
			},
			{
				path: 'apply-for-final-approval',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceApplyForFinalApprovalComponent
			},
			{
				path: 'final-approval',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceFinalApprovalComponent
			},
			{
				path: 'all',
				canActivate: [InNavGuardService],
				component: NceAdminAllComponent
			},
			{
				path: 'view/:id',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceViewComponent
			},
			{
				path: 'request/:id',
				canActivate: [InNavGuardService],
				component: NceAdminRequestComponent
			},
			{
				path: 'briefing-document',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceBriefingDocumentComponent
			},
			{
				path: 'appointment-upload',
				canActivate: [InNavGuardService],
				canDeactivate: [OutNavGuardService],
				component: NceAppointmentUploadComponent
			},
		]
	},
	{
		path: 'create-account',
		canActivate: [InNavGuardService],
		component: AdminCreateAccountComponent
	},
	{
		path: 'user-account',
		canActivate: [InNavGuardService],
		component: AdminUserAccountComponent
	},
	{
		path: 'user-details/:userid',
		canActivate: [InNavGuardService],
		component: AdminViewUserDetailsComponent
	},
	{
		path: 'update-profile',
		canActivate: [InNavGuardService],
		component: ProfileUpdateProfileComponent
	},
	{
		//GANESH
		path: 'admin-report',
		canActivate: [InNavGuardService],
		component: AdminReportComponent

	},

	//Kowsalya
	{
		path: 'configuration',
		canDeactivate: [OutNavGuardService],  
		children:
		[	
			{   
				path: 'payment-tnc',
				canActivate: [InNavGuardService], 
				component: paymentTnCComponent
			}
		]
	},
			{   
				path: 'plantmap-admin-all',
				canActivate: [InNavGuardService], 
				component: PlantmapAdminAllComponent
			}
	//Kowsalya
];

// const routes: Routes = [
// 	{
// 		path: '',   
// 		redirectTo: '/maintenance', 
// 		pathMatch: 'full'
// 	},
// 	{   
// 		path: 'maintenance',
// 		component: MaintenanceComponent
// 	},
// 	{ path: '**', component: MaintenanceComponent }
// ];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/app.routes.ts